import { render } from "./IconArrowHint.vue?vue&type=template&id=5bb6eb6d"
import script from "./IconArrowHint.vue?vue&type=script&lang=js"
export * from "./IconArrowHint.vue?vue&type=script&lang=js"
script.render = render

export default script